import dayjs from "dayjs";
import _ from "lodash";
import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  background: red;
`;

const ClockWrapper = styled.div`
  width: 100%;
  height: 100%;
  /* width: 300px;
  height: 300px; */
  border-radius: 50%;
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  text-align: center;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AnalogCenterDot = styled.div`
  background: #222;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid #444;
`;

const HandAnalog = styled.div`
  position: absolute;
  background: ${({ color }) => color || "#444"};
  width: ${({ width }) => width || "4px"};
  height: ${({ height }) => height || "80px"};
  top: 50%;
  left: 50%;
  transform-origin: 50% 100%;
  transform: ${({ angle }) => `translate(-50%, -100%) rotate(${angle}deg)`};
  border-radius: 10px;
  z-index: 1;
`;

const AnalogNumber = styled.span`
  position: absolute;
  font-family: "Sarabun";
  font-weight: 700;
  transform: translate(-50%, -50%);
  top: ${({ top }) => top};
  left: ${({ left }) => left};
`;
const CLOCK_NUMBERS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

const calculatePosition = ({ angle, radius }) => {
  const radian = (Math.PI / 180) * angle; // แปลงองศาเป็นเรเดียน
  const x = 50 + radius * Math.sin(radian); // ค่า x เปอร์เซ็นต์
  const y = 50 - radius * Math.cos(radian); // ค่า y เปอร์เซ็นต์
  return { x: `${x}%`, y: `${y}%` };
};

export const AnalogClock = () => {
  //   const [time, setTime] = useState(dayjs().hour(12).minute(30).second(1));
  const [time, setTime] = useState(dayjs());

  const numbers = _.map(CLOCK_NUMBERS, (num, index) => {
    const angle = index * 30; // 30 องศาต่อ 1 เลข
    const { x, y } = calculatePosition({ angle, radius: 42 }); // ใช้ radius 42% คือ ระยะห่างจากวงกลม
    return { label: num, top: y, left: x };
  });

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(dayjs());
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <Container>
      <ClockWrapper>
        <HandAnalog
          color="#222"
          width="6px"
          height="20%"
          angle={time.hour() * 30 + time.minute() * 0.5}
        />
        <HandAnalog
          color="#444"
          width="4px"
          height="30%"
          angle={time.minute() * 6}
        />
        <HandAnalog
          color="red"
          width="2px"
          height="38%"
          angle={time.second() * 6}
        />
        <AnalogCenterDot />
        {_.map(numbers, (num, index) => (
          <AnalogNumber key={index} top={num.top} left={num.left}>
            {num.label}
          </AnalogNumber>
        ))}
      </ClockWrapper>
    </Container>
  );
};
